export const COLOMBIA_CITIES: string[] = [
  'Bogota',
  'Medellin',
  'Cali',
  'Barranquilla',
  'Cartagena',
  'Bucaramanga',
  'Pereira',
  'Santa Marta',
  'Manizales',
  'Ibague',
  'Pasto',
  'Villavicencio',
  'Neiva',
  'Armenia',
  'Monteria',
  'Valledupar',
  'Sincelejo',
  'Tunja',
  'Popayan',
  'Florencia',
  'Riohacha',
  'Yopal',
  'Quibdo',
  'Arauca',
  'Mocoa',
  'San Andres',
  'Leticia',
  'Soledad',
  'Envigado',
  'Bello',
  'Itagui',
  'Dosquebradas',
  'Facatativa',
  'Chia',
  'Zipaquira',
  'Cucuta',
  'Rionegro',
  'Girardot',
  'Sogamoso',
  'Palmira'
];
